import React, { createContext, useContext, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";

interface LoaderContextType {
  isLoading: boolean;   // Expose isLoading state
  showLoader: () => void;
  hideLoader: () => void;
}

export const LoaderContext = createContext<LoaderContextType | undefined>(
  undefined
);

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error("useLoader must be used within a LoaderProvider");
  }
  return context;
};

export const LoaderProvider: React.FC<any> = ({ children }) => {
  const loaderContainerStyle: React.CSSProperties = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 9999,
    pointerEvents: "none"
  };

  const [isLoading, setLoading] = useState(false);  // Track loading state

  const showLoader = () => {
    setLoading(true);
  };

  const hideLoader = () => {
    setLoading(false);
  };

  return (
    <LoaderContext.Provider value={{ isLoading, showLoader, hideLoader }}>  {/* Pass isLoading */}
      {children}
      {isLoading && (  // Show loader based on isLoading state
        <div style={loaderContainerStyle}>
          <CircularProgress size={130} />
        </div>
      )}
    </LoaderContext.Provider>
  );
};
